(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutramerican-region-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('pointerdown', function (event) {
    document.querySelectorAll('.nutra-region-picker[open]').forEach(function (picker) {
      if (!picker.contains(event.target)) {
        picker.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.nutra-region-picker[open]').forEach(function (picker) {
      picker.removeAttribute('open');
      picker.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
